import React, { Component } from 'react'

export class user extends Component {
    render() {
        return (
            <div>
                User
            </div>
        )
    }
}

export default user
